import type { GoodsReceiptPallet, WarehouseType } from "@/graphql/codegen/graphql"
import type { DestinationOverride } from "@/screens/WarehouseReceiving/components/GoodsReceiptPalletsTable"

export const canFinishCheckIn = (
  pallets: GoodsReceiptPallet[],
  destinationOverrides: Map<string, DestinationOverride>,
  warehouseType?: WarehouseType | null
): boolean => {
  // Unmanaged and consignment warehouses don't require destination validation
  if (warehouseType === "AKROCHEM_UNMANAGED" || warehouseType === "CONSIGNMENT") {
    return true
  }

  // For managed warehouses (AKROCHEM_MANAGED), every pallet row must have a destination override and no duplicating destinations
  const destinationOverridesArray = Array.from(destinationOverrides.values())

  const hasDuplicatingDestinations = destinationOverridesArray.some(
    (override, index, destinationOverrides) =>
      destinationOverrides.findIndex((o) => o.warehouseShelvingId === override.warehouseShelvingId) !== index
  )

  if (hasDuplicatingDestinations) {
    return false
  }

  return pallets.every((pallet) => {
    const override = destinationOverrides.get(pallet.goodsReceiptPalletId)
    return Boolean(override)
  })
}
